import { render, staticRenderFns } from "./wenXueChangShiPublic.vue?vue&type=template&id=6d4dc851&scoped=true&"
import script from "./wenXueChangShiPublic.vue?vue&type=script&lang=js&"
export * from "./wenXueChangShiPublic.vue?vue&type=script&lang=js&"
import style0 from "./wenXueChangShiPublic.vue?vue&type=style&index=0&id=6d4dc851&prod&lang=scss&"
import style1 from "./wenXueChangShiPublic.vue?vue&type=style&index=1&id=6d4dc851&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4dc851",
  null
  
)

export default component.exports